import React, { useEffect, useRef, useState } from 'react';
import MainSwiper from '../swiper/MainSwiper';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Popup from '../Popup/Popup';
import KakaoMap from '../KakaoMap/KakaoMap';
import KakaoMap2 from '../KakaoMap/KaKaoMap2';
import KakaoMap3 from '../KakaoMap/KaKaoMap3';

const Home = () => {
  const navigate = useNavigate();
  const containerRef = useRef(null);
  const containerRef2 = useRef(null);
  const containerRef3 = useRef(null);
  const containerRef4 = useRef(null);
  const [thumbFailMap, setThumbFailMap] = useState({});

  const [noticeList, setNoticeList] = useState([]);
  const [businessList, setBusinessList] = useState([]);
  const [educationList, setEcucationList] = useState([]);
  const [newsList, setNewsList] = useState([]);
  const [corporateList, setCorporateList] = useState([]); // ✅ 입주기업 리스트

  const topRef = useRef(null);
  const [searchText, setSearchText] = useState('');
  const [noticeTab, setNoticeTab] = useState('notice');
  const [menuIndex, setMenuIndex] = useState(0);

  const sliderRef = useRef(null);

  const [activeCenter, setActiveCenter] = useState('dangjin');

  const centers = [
    {
      id: 'dangjin',
      label: '당진 본원',
      subtitle: '충남산학융합원',
      address: '충남 당진시 석문면 산단7로 201, 충남산학융합원 302호',
      tel: '041-354-8558',
      fax: '041-354-8559',
      email: 'master@ciuc.or.kr',
      MapComponent: KakaoMap,
    },
    {
      id: 'asan',
      label: '아산센터',
      subtitle: '천안아산 KTX역 인근',
      address: '충남 아산시 배방읍 광장로 210 와이몰 C-104~106, C-217',
      tel: '041-522-0420',
      fax: '041-354-8559',
      email: 'joye@ciuc.or.kr',
      MapComponent: KakaoMap2,
    },
    {
      id: 'hongseong',
      label: '홍성센터',
      subtitle: '혜전대학교 캠퍼스 내',
      address: '충남 홍성군 홍성읍 대학길 25 혜전대학교 대학본부 203호',
      tel: '041-641-7994',
      fax: '041-354-8559',
      email: 'choisy@ciuc.or.kr',
      MapComponent: KakaoMap3,
    },
  ];

  const currentCenter = centers.find((c) => c.id === activeCenter) ?? centers[0];
  const CurrentMap = currentCenter.MapComponent;

  // ✅ 홈 메뉴 슬라이드(반응형) - "보이는 개수" 기준과 translate 기준을 동일하게 맞춤
  const TOTAL_MENU_COUNT = 7;

  // ✅ idx 기반으로 실패 마킹
  const markThumbFail = (id) => {
    if (!id) return;
    setThumbFailMap((prev) => {
      if (prev[id]) return prev;
      return { ...prev, [id]: true };
    });
  };

  // ✅ 보도자료: PC 8개 / 모바일(<=768) 4개
  const getPressPerPage = () => {
    const w = typeof window !== 'undefined' ? window.innerWidth : 1600;
    return w <= 768 ? 4 : 8;
  };

  const [pressPerPage, setPressPerPage] = useState(getPressPerPage());
  const [pressPage, setPressPage] = useState(0);

  useEffect(() => {
    const onResize = () => setPressPerPage(getPressPerPage());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    // ✅ 페이지 사이즈 바뀌면 현재 page가 범위 밖이 될 수 있으니 안전하게 0으로
    setPressPage(0);
  }, [pressPerPage]);

  // ✅ 현재 페이지에 보여줄 보도자료
  const visiblePressList = React.useMemo(() => {
    const start = pressPage * pressPerPage;
    return (newsList || []).slice(start, start + pressPerPage);
  }, [newsList, pressPage, pressPerPage]);

  const pressCanPrev = pressPage > 0;
  const pressCanNext = (pressPage + 1) * pressPerPage < (newsList?.length || 0);

  const handlePressPrev = () => {
    if (!pressCanPrev) return;
    setPressPage((p) => p - 1);
  };

  const handlePressNext = () => {
    if (!pressCanNext) return;
    setPressPage((p) => p + 1);
  };

  const getVisibleCount = () => {
    const w = typeof window !== 'undefined' ? window.innerWidth : 1600;
    if (w <= 480) return 3;
    if (w <= 768) return 4;
    if (w <= 1024) return 5;
    if (w <= 1440) return 6;
    return 7;
  };

  const [visibleMenuCount, setVisibleMenuCount] = useState(getVisibleCount());

  useEffect(() => {
    const onResize = () => setVisibleMenuCount(getVisibleCount());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const maxMenuIndex = Math.max(0, TOTAL_MENU_COUNT - visibleMenuCount);

  useEffect(() => {
    setMenuIndex((prev) => Math.min(prev, maxMenuIndex));
  }, [visibleMenuCount, maxMenuIndex]);

  const handlePrevMenu = () => {
    setMenuIndex((prev) => Math.max(0, prev - 1));
  };

  const handleNextMenu = () => {
    setMenuIndex((prev) => Math.min(maxMenuIndex, prev + 1));
  };

  // 공통 날짜 포맷: YYYY-MM-DD
  function formatDate(value) {
    if (!value) return '';
    const isoString = String(value).trim();
    if (!isoString) return '';

    const date = new Date(isoString);
    if (isNaN(date.getTime())) {
      return isoString;
    }

    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  // ✅ 입주기업 슬라이드 상태 (쭉 흘러가는 배너)
  const [corporateOffset, setCorporateOffset] = useState(0); // 현재 X축 오프셋(px)
  const [corporatePlaying, setCorporatePlaying] = useState(true); // 재생/일시정지
  const corporateTrackRef = useRef(null); // 트랙 ref

  // 보도자료 카드 한 칸씩 좌우로 이동
  const scrollPress = (direction = 1) => {
    if (!sliderRef.current) return;
    const track = sliderRef.current;
    const card = track.querySelector('.press-card');
    if (!card) return;

    const cardRect = card.getBoundingClientRect();
    const step = cardRect.width + 24; // 카드 너비 + gap

    track.scrollBy({
      left: direction * step,
      behavior: 'smooth',
    });
  };

  const handlePrev = () => scrollPress(-1);
  const handleNext = () => scrollPress(1);

  // ✅ 보도자료용: content 안에서 첫 번째 <img> src 추출
  const getFirstImageSrc = (html) => {
    if (!html) return null;

    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const img = doc.querySelector('img');
      if (!img) return null;

      let src = (img.getAttribute('src') || '').trim();
      if (!src) return null;

      // 이미 절대경로(https://..., http://..., //...) or data URL 이면 그대로 사용
      if (/^(https?:)?\/\//.test(src) || src.startsWith('data:')) {
        if (src.startsWith('//') && typeof window !== 'undefined') {
          return `${window.location.protocol}${src}`;
        }
        return src;
      }

      // /uploads/파일명 (> localhost)
      if (src.startsWith('/uploads')) {
        return `https://ciuc.or.kr:8443${src}`;
      }

      // 그냥 파일명만 있는 경우 → /uploads/ 아래에 있다고 가정
      return `https://ciuc.or.kr:8443/uploads/${src}`;
    } catch (e) {
      console.error('getFirstImageSrc error:', e);
      return null;
    }
  };

  // ✅ 보도자료 카드 텍스트 정리
  const getPlainText = (html) => {
    if (!html) return 'No content available';
    return html
      .replace(/<\/?[^>]+(>|$)/g, '')
      .replace(/&nbsp;/g, ' ')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&');
  };

  useEffect(() => {
    // 공지사항
    const fetchNotice = async () => {
      try {
        const response = await axios.get('https://ciuc.or.kr:8443/api/get/home/notice');
        setNoticeList(response.data);
      } catch (err) {
        console.log('공지사항 호출 오류:', err);
      }
    };
    // 사업공고
    const fetchBusiness = async () => {
      try {
        const response = await axios.get('https://ciuc.or.kr:8443/api/get/home/business');
        setBusinessList(response.data);
      } catch (err) {
        console.log('사업공고 호출 오류:', err);
      }
    };
    // 교육공고
    const fetchEducation = async () => {
      try {
        const response = await axios.get('https://ciuc.or.kr:8443/api/get/home/education');
        setEcucationList(response.data);
      } catch (err) {
        console.log('교육공고 호출 오류:', err);
      }
    };
    // 보도자료(뉴스)
    const fetchNews = async () => {
      try {
        const response = await axios.get('https://ciuc.or.kr:8443/api/get/home/news');
        setNewsList(response.data);
      } catch (err) {
        console.log('보도자료 호출 오류:', err);
      }
    };
    // ✅ 입주기업 목록
    const fetchCorporate = async () => {
      try {
        const response = await axios.get('https://ciuc.or.kr:8443/api/get/home/corporate');
        setCorporateList(response.data || []);
      } catch (err) {
        console.log('corporate 호출 오류:', err);
      }
    };

    fetchNotice();
    fetchBusiness();
    fetchEducation();
    fetchNews();
    fetchCorporate();
  }, []);

  // ✅ 입주기업 배너 자동 슬라이드 (쫘라락)
  useEffect(() => {
    if (!corporatePlaying) return;
    if (!corporateTrackRef.current) return;
    if (corporateList.length === 0) return;

    const slider = corporateTrackRef.current;
    const parent = slider.parentElement;
    if (!parent) return;

    const speed = 1.2; // px 단위 (속도)
    const interval = 20; // ms

    const id = setInterval(() => {
      setCorporateOffset((prev) => {
        const trackWidth = slider.scrollWidth;
        const viewportWidth = parent.clientWidth;
        const maxOffset = trackWidth - viewportWidth;

        if (maxOffset <= 0) return 0;

        const next = prev + speed;
        // 끝까지 가면 처음으로 자연스럽게 리셋
        return next > maxOffset ? 0 : next;
      });
    }, interval);

    return () => clearInterval(id);
  }, [corporatePlaying, corporateList.length]);

  // 버튼: 이전 / 다음 → 강제로 offset 이동
  const shiftCorporateOffset = (direction) => {
    if (!corporateTrackRef.current) return;
    const slider = corporateTrackRef.current;
    const parent = slider.parentElement;
    if (!parent) return;

    const step = 220; // 한 번에 이동할 px
    const trackWidth = slider.scrollWidth;
    const viewportWidth = parent.clientWidth;
    const maxOffset = trackWidth - viewportWidth;
    if (maxOffset <= 0) return;

    setCorporateOffset((prev) => {
      let next = prev + direction * step;
      if (next < 0) next = maxOffset;
      if (next > maxOffset) next = 0;
      return next;
    });
  };

  const visitGuideMap = {
    '당진 본원': '당진IC에서 10분 거리이며, 당진시청 방면으로 이동 후 ○○사거리에서 우회전하여 방문하시면 됩니다.',
    아산센터: '아산역에서 차량 5분 거리로, 온양온천 방면으로 이동 후 ○○빌딩 주차장을 이용하시면 됩니다.',
    홍성센터: '홍성역 인근에 위치해 있으며, 홍주문화회관 방면으로 이동 후 도보 5분 거리입니다.',
  };

  const handleCorporatePrev = () => shiftCorporateOffset(-1);
  const handleCorporateNext = () => shiftCorporateOffset(1);
  const toggleCorporatePlay = () => setCorporatePlaying((prev) => !prev);

  const hitCount = async (idx) => {
    try {
      await axios.post(`https://ciuc.or.kr:8443/api/post/board/hit_count/${idx}`);
    } catch (err) {
      console.log(err);
    }
  };

  const moveBoard = (cate) => {
    console.log('moveBoard 호출:', cate);
    navigate(`/board/${cate}`, { state: { cate: cate } });
  };

  const handleRowClick = (data) => {
    if (data.idx) {
      hitCount(data.idx);
      navigate(`/board/${data.category}/${data.idx}`, { state: { data } });
    } else {
      console.error('idx is undefined!');
    }
  };

  const handleImageBbsClick = async (data) => {
    console.log('datadata', data);
    console.log('idxidx', data.idx);
    if (data.idx) {
      await hitCount(data.idx);
      const path = `/board/${data.category}/${data.idx}`;
      console.log('Navigating to:', path);
      navigate(path, { state: { data } });
    } else {
      console.error('data.idx is undefined or falsy');
    }
  };

  const cleanHtml = (html) => {
    if (!html) return '';
    let text = html.replace(/<[^>]+>/g, '');
    const textarea = document.createElement('textarea');
    textarea.innerHTML = text;
    return textarea.value.trim();
  };

  const getFirstValidContent = (list) => {
    for (let i = 0; i < list.length; i++) {
      const cleaned = cleanHtml(list[i].content);
      if (cleaned && cleaned.length > 0) {
        return cleaned;
      }
    }
    return '';
  };

  const getCurrentList = () => {
    if (noticeTab === 'notice') return noticeList;
    if (noticeTab === 'business') return businessList;
    if (noticeTab === 'education') return educationList;
    return [];
  };

  // NEW 뱃지용
  const isNew = (dateString) => {
    if (!dateString) return false;
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return false;

    const today = new Date();
    const diffTime = Math.abs(date - today);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays <= 7;
  };

  const scrollTop = () => {
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handlerIntegratedSearch = () => {
    navigate('/integratedSearch', { state: { searchText: searchText } });
  };

  return (
    <div className="main_wrap">
      <Popup />
      <div className="main_back" ref={topRef}>
        <div className="main_banner_box">
          <MainSwiper />
        </div>

        {/* 1. 상단 메뉴 슬라이드 */}
        <div className="first_container">
          <div className="home_menu_container">
            {/* Viewport */}
            <div className="home_menu_viewport" style={{ ['--perView']: visibleMenuCount }}>
              <div
                className="home_menu_box"
                style={{
                  transform: `translateX(-${menuIndex * (100 / visibleMenuCount)}%)`,
                }}
                ref={containerRef}
              >
                <div className="home_menu_row">
                  <div
                    className="home_menu_icon first"
                    onClick={() => window.open('https://ccu.learnchy.com/', '_blank')}
                  />
                  <div className="home_menu_label">LMS</div>
                </div>

                <div className="home_menu_row">
                  <div className="home_menu_icon second" onClick={() => moveBoard('facility/write')} />
                  <div className="home_menu_label">시설예약</div>
                </div>

                <div className="home_menu_row">
                  <div className="home_menu_icon third" onClick={() => navigate('floor')} />
                  <div className="home_menu_label">층별안내</div>
                </div>

                <div className="home_menu_row">
                  <div className="home_menu_icon fourth" onClick={() => navigate('company')} />
                  <div className="home_menu_label">입주기업 현황</div>
                </div>

                <div className="home_menu_row">
                  <div className="home_menu_icon fifth" onClick={() => navigate('fusionSupportProgram')} />
                  <div className="home_menu_label">사업분야</div>
                </div>

                <div className="home_menu_row">
                  <div className="home_menu_icon sixth" onClick={() => navigate('regulations')} />
                  <div className="home_menu_label">관리규정</div>
                </div>

                <div className="home_menu_row">
                  <div className="home_menu_icon seventh" onClick={() => moveBoard('inquiry')} />
                  <div className="home_menu_label">입주문의</div>
                </div>

                <div className="home_menu_row">
                  <div className="home_menu_icon eighth" onClick={() => navigate('map')} />
                  <div className="home_menu_label">찾아오시는 길</div>
                </div>
              </div>
            </div>
          </div>

          {/* 2. 공지/사업/채용 + 오른쪽 배너 */}
          <div className="first_back">
            {/* 왼쪽 공지 패널 (50%) */}
            <div className="first_row notice-panel">
              <div className="notice_header">
                <div className="notice_tabs">
                  <button
                    type="button"
                    className={`notice_tab ${noticeTab === 'notice' ? 'active' : ''}`}
                    onClick={() => setNoticeTab('notice')}
                  >
                    공지사항
                  </button>
                  <button
                    type="button"
                    className={`notice_tab ${noticeTab === 'business' ? 'active' : ''}`}
                    onClick={() => setNoticeTab('business')}
                  >
                    사업공고
                  </button>
                  <button
                    type="button"
                    className={`notice_tab ${noticeTab === 'education' ? 'active' : ''}`}
                    onClick={() => setNoticeTab('education')}
                  >
                    교육공고
                  </button>
                </div>

                <button type="button" className="notice_more_btn" onClick={() => moveBoard(noticeTab)}>
                  <span className="sr_only">더보기</span>
                  <span className="icon_plus" />
                </button>
              </div>

              <div className="notice_list">
                {(() => {
                  const list = getCurrentList();
                  if (!list || list.length === 0) return null;

                  const highlight = list[0];
                  const subList = list.slice(1, 5);
                  const highlightContent = getFirstValidContent(list);

                  const getDateParts = (dateStr) => {
                    if (!dateStr) return { day: '', ym: '' };
                    const d = new Date(dateStr);
                    if (isNaN(d.getTime())) return { day: '', ym: '' };
                    const day = String(d.getDate()).padStart(2, '0');
                    const ym = `${d.getFullYear()}.${String(d.getMonth() + 1).padStart(2, '0')}`;
                    return { day, ym };
                  };

                  const { day, ym } = getDateParts(highlight.date);

                  return (
                    <>
                      <div className="notice_item notice_item_highlight" onClick={() => handleRowClick(highlight)}>
                        <div className="notice_highlight_date">
                          <span className="notice_highlight_day">{day}</span>
                          <span className="notice_highlight_ym">{ym}</span>
                        </div>

                        <div className="notice_highlight_content">
                          <p className="notice_highlight_title">{highlight.title}</p>
                          <p className="notice_highlight_desc">{highlightContent}</p>
                        </div>
                      </div>

                      <div className="notice_sub_list">
                        {subList.map((data, index) => (
                          <div className="notice_item" key={index} onClick={() => handleRowClick(data)}>
                            <div className="notice_title_area">
                              <span className="notice_title">{data.title}</span>
                              {isNew(data.date) && <span className="badge_new">N</span>}
                            </div>
                            <span className="notice_date">{formatDate(data.date)}</span>
                          </div>
                        ))}
                      </div>
                    </>
                  );
                })()}
              </div>
            </div>

            {/* 오른쪽 15% - 채용공고 박스 (예시) */}
            <div className="promo_col promo_col_side">
              <div className="promo_box promo_recruit" onClick={() => moveBoard('employment')}>
                <div className="promo_recruit_inner">
                  <p className="promo_recruit_label">Recruit</p>
                  <p className="promo_recruit_title">채용공고</p>
                  <p className="promo_recruit_desc">충남산학융합원의 채용 소식을 한눈에 확인해 보세요.</p>
                  <button type="button" className="promo_recruit_btn">
                    채용공고 바로가기
                  </button>
                </div>
              </div>
            </div>

            {/* 가운데 35% - 홍보영상 박스 */}
            <div className="promo_col promo_col_video">
              <div className="promo_box promo_lab">
                <div className="youtube_player_frame">
                  <iframe
                    src="https://www.youtube.com/embed/Y5LwQzSsSH0?autoplay=1&mute=1&controls=0&playsinline=1&modestbranding=1&rel=0&enablejsapi=1"
                    title="융합원 소개자료 영상"
                    frameBorder="0"
                    allow="autoplay; encrypted-media; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>

              {/* 🔥 네이버 블로그 바로가기 버튼 박스 */}
              <a
                href="https://blog.naver.com/yourBlog"
                target="_blank"
                rel="noopener noreferrer"
                className="promo_box promo_blog_link"
              >
                <div className="blog_link_inner">
                  <div className="blog_icon"></div>
                  <div className="blog_text">충남산학융합원 네이버 블로그</div>
                  <div className="right-arrow"></div>
                </div>
              </a>
            </div>
          </div>
        </div>

        {/* 2. 카드 그리드 섹션 */}
        <div className="grid_section_wrap">
          <div className="grid_container">
            {/* 1. 사업분야 */}
            <section className="card card_business">
              <div className="card_inner">
                <p className="card_kicker">Business Fields</p>
                <h2 className="card_title">사업분야</h2>
                <p className="card_desc">융합원에서 수행 중인 주요 사업을 분야별로 한 번에 확인해 보세요.</p>
              </div>

              <div className="business_hover_layer">
                <p className="business_label"></p>

                <div className="business_tab_list">
                  <a href="/fusionSupportProgram" className="business_tab_item">
                    <span className="tab_index">01</span>
                    <span className="tab_title">산학융합지구조성사업</span>
                  </a>

                  <a href="/business/chungnamInnovationProject" className="business_tab_item">
                    <span className="tab_index">02</span>
                    <span className="tab_title">기업지원사업</span>
                  </a>

                  <a href="/business/localIndustryTalentDevelopment" className="business_tab_item">
                    <span className="tab_index">03</span>
                    <span className="tab_title">인재양성사업</span>
                  </a>

                  <a href="/business/dangjinStartupSupport" className="business_tab_item">
                    <span className="tab_index">04</span>
                    <span className="tab_title">창업육성사업</span>
                  </a>
                </div>
              </div>
            </section>

            {/* 2. 융합원소개 */}
            <section className="card card_about">
              <div className="card_inner">
                <p className="card_kicker">About CN-IUC</p>
                <h2 className="card_title">융합원소개</h2>
                <p className="card_desc">충남산학융합원의 설립 목적과 역할, 추진 체계를 소개합니다.</p>
              </div>
            </section>

            {/* 3. 융합원 아카이브 */}
            <section className="card card_youtube">
              <div className="promo_box promo_lab">
                {/* 영어 키커 */}
                <p className="promo_lab_kicker">CN-IUC Archive</p>

                {/* 텍스트 그룹 */}
                <div className="promo_lab_text">
                  <p className="promo_lab_title">융합원아카이브</p>
                  <p className="promo_lab_desc">연구·사업·교육 등 융합원의 활동을 아카이브 형태로 만나보세요.</p>
                </div>
              </div>
            </section>

            {/* 4. 층별안내 */}
            <section className="card card_floor">
              <div className="card_inner">
                <p className="card_kicker">Floor Guide</p>
                <h2 className="card_title">층별안내</h2>
                <p className="card_desc">연구실, 공용공간, 편의시설 등 층별 배치 정보를 한 번에 확인하세요.</p>
              </div>
            </section>

            {/* 5. 시설예약 */}
            <section className="card card_reservation">
              <div className="card_inner">
                <p className="card_kicker">Facility Reservation</p>
                <h2 className="card_title">시설예약</h2>
                <p className="card_desc">회의실, 세미나실, 장비 등 온라인으로 간편하게 예약할 수 있습니다.</p>
              </div>
            </section>
          </div>
        </div>

        {/* 3. 보도자료 – 카드 그리드 */}
        <div className="second_container">
          <div className="second_back" ref={containerRef2}>
            {/* 상단 타이틀 / 더보기 */}
            <div className="press_header_row">
              <div className="press_title_centerbox">
                <span className="line left"></span>
                <span className="dot"></span>
                <span className="press_title_text">보도자료</span>
                <span className="dot"></span>
                <span className="line right"></span>
              </div>

              <button className="press_more_btn" onClick={() => navigate('/board/news')}>
                더보기 {'>'}
              </button>
            </div>

            {/* ✅ 카드 그리드 */}
            <div className="press_grid">
              {visiblePressList.map((data) => {
                const plainText = getPlainText(data.content);
                const rawDate = data.date || data.reg_date || data.created_at || '';
                const dateText = formatDate(rawDate);

                const isPressNew = (() => {
                  if (!rawDate) return false;
                  const d = new Date(rawDate);
                  if (Number.isNaN(d.getTime())) return false;
                  const today = new Date();
                  return (today - d) / (1000 * 60 * 60 * 24) <= 3;
                })();

                const firstImgSrc = getFirstImageSrc(data.content);

                // ✅ idx 기준으로 실패 여부 판단 (index 쓰면 페이지/정렬에서 꼬임)
                const uid = data.idx ?? `${data.category || 'news'}-${data.title || ''}-${rawDate || ''}`;
                const hasThumb = !!firstImgSrc && !thumbFailMap[uid];

                return (
                  <div
                    className="press_card"
                    key={uid}
                    onClick={() => handleImageBbsClick(data)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => e.key === 'Enter' && handleImageBbsClick(data)}
                  >
                    <div className={`press_thumb ${hasThumb ? '' : 'no-thumb'}`}>
                      {hasThumb ? (
                        <img
                          className="press_thumb_img"
                          src={firstImgSrc}
                          alt=""
                          loading="lazy"
                          onError={() => markThumbFail(uid)}
                        />
                      ) : (
                        <div className="thumb_fallback">
                          <span className="thumb_hint"></span>
                        </div>
                      )}

                      {/* ✅ 날짜 제거, NEW만 유지 */}
                      <div className="press_badges">
                        {isPressNew && <span className="press_new_badge" aria-label="new" />}
                      </div>
                    </div>

                    <div className="press_body">
                      {/* ✅ 제목 위 날짜 */}
                      {dateText && <div className="press_meta">{dateText}</div>}

                      <div className="press_title">{data.title}</div>
                      <div className="press_desc">{plainText}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* 4. 찾아오시는 길 */}
        <div className="visit_section">
          <div className="visit_back">
            {/* 왼쪽 센터 선택 / 정보 */}
            <div className="visit_left">
              <div className="visit_header">
                <div className="visit_header_left">
                  <span className="visit_accent_bar" />
                  <div className="visit_title_box">
                    <p className="visit_title">찾아오시는 길</p>
                    <p className="visit_subtitle">충남산학융합원 및 각 센터 위치를 한 번에 확인하세요.</p>
                  </div>
                </div>
              </div>

              <div className="visit_center_tabs">
                {centers.map((center) => (
                  <button
                    key={center.id}
                    type="button"
                    className={`visit_tab visit_tab_${center.id} ${activeCenter === center.id ? 'active' : ''}`}
                    onClick={() => setActiveCenter(center.id)}
                  >
                    <div className="visit_tab_main">
                      <span className="visit_tab_label">{center.label}</span>
                      <span className="visit_tab_arrow">&gt;</span>
                    </div>
                    <span className="visit_tab_sub">{center.subtitle}</span>
                  </button>
                ))}
              </div>

              {/* ✅ 카드형 CONTACT & LOCATION */}
              <div className="visit_info_card">
                <div className="visit_info_card_head">
                  <div className="visit_info_head_left">
                    <div className="visit_info_kicker">CONTACT & LOCATION</div>
                    <div className="visit_info_heading">
                      <span className="visit_info_heading_dot" />
                      <span className="visit_info_heading_text">{currentCenter.label}</span>
                    </div>
                  </div>

                  <button
                    type="button"
                    className="visit_info_copybtn"
                    onClick={() => {
                      const text = `${currentCenter.address}\nTEL: ${currentCenter.tel}\nFAX: ${currentCenter.fax}\nE-MAIL: ${currentCenter.email}`;
                      if (navigator?.clipboard?.writeText) navigator.clipboard.writeText(text);
                    }}
                  >
                    주소 복사
                  </button>
                </div>

                <div className="visit_info_blocks">
                  <div className="visit_block">
                    <div className="visit_block_head">
                      <span className="visit_block_title">주소</span>
                    </div>
                    <div className="visit_block_value">{currentCenter.address}</div>
                  </div>

                  <div className="visit_block">
                    <div className="visit_block_head">
                      <span className="visit_block_title">상세안내</span>
                    </div>
                    <div className="visit_block_value">
                      {visitGuideMap[currentCenter.label] || '상세 안내 준비 중입니다.'}
                    </div>
                  </div>

                  <div className="visit_contact_grid">
                    <div className="visit_contact_item">
                      <div className="visit_contact_label">TEL</div>
                      <div className="visit_contact_value strong">{currentCenter.tel}</div>
                    </div>

                    <div className="visit_contact_item">
                      <div className="visit_contact_label">FAX</div>
                      <div className="visit_contact_value">{currentCenter.fax}</div>
                    </div>

                    <div className="visit_contact_item full">
                      <div className="visit_contact_label">E-MAIL</div>
                      <div className="visit_contact_value strong">{currentCenter.email}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 오른쪽 지도 */}
            <div className="visit_right">
              <div className="visit_map_box">
                <CurrentMap />
              </div>
            </div>
          </div>
        </div>

        {/* 5. 입주기업 슬라이더 */}
        <div className="third-container-bordertop">
          <div className="third_container second">
            <div className="third_back">
              <div className="corporate_controls">
                <button type="button" className="third_btn" onClick={handleCorporatePrev}>
                  &#60;
                </button>
                <button type="button" className="third_btn" onClick={toggleCorporatePlay}>
                  {corporatePlaying ? 'Ⅱ' : '▶'}
                </button>
                <button type="button" className="third_btn" onClick={handleCorporateNext}>
                  &#62;
                </button>
              </div>

              <div className="corporate_slider">
                <div
                  className="corporate_slider_track"
                  ref={corporateTrackRef}
                  style={{ transform: `translateX(-${corporateOffset}px)` }}
                >
                  {[...corporateList, ...corporateList].map((corp, idx) => (
                    <div className="corporate_slide" key={idx}>
                      <button
                        type="button"
                        className="corporate_card"
                        onClick={() => {
                          if (corp.homepage) {
                            window.open(corp.homepage, '_blank', 'noopener,noreferrer');
                          }
                        }}
                      >
                        <div
                          className="corporate_logo"
                          style={{
                            backgroundImage: `url(https://ciuc.or.kr:8443/uploads/${
                              corp.img1 ? corp.img1 : 'src/assets/image/no_image.png'
                            })`,
                          }}
                        />
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
